import axios from 'axios'
import config from '@/services/config'

const baseURL = config.backendURL || process.env.VUE_APP_BACKEND_URL || ''

const apiClient = axios.create({
    baseURL,
    // Mirror previous fetches that used credentials: 'include'
    withCredentials: true,
})

apiClient.interceptors.request.use((requestConfig) => {
    const headers = requestConfig.headers || {}
    const subdomainHeader = config.getSubdomainHeader()
    const token = config.sessionToken

    // Merge subdomain header without overwriting explicit caller headers.
    requestConfig.headers = { ...headers, ...subdomainHeader }

    // Attach Authorization only if caller didn't set it.
    if (token && !headers.Authorization && !headers.authorization) {
        requestConfig.headers.Authorization = `Bearer ${token}`
    }

    // Default JSON content type for write operations if not provided.
    const method = (requestConfig.method || '').toLowerCase()
    if (
        ['post', 'put', 'patch'].includes(method) &&
        !requestConfig.headers['Content-Type'] &&
        !requestConfig.headers['content-type']
    ) {
        requestConfig.headers['Content-Type'] = 'application/json'
    }

    return requestConfig
})

export default apiClient
